import { Stack, Card, Heading, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useState, useEffect } from 'react';

interface PopularRouteProps {
  destination: string;
  header: string;
  link: string;
}

const flightsLinkStyles = css`
  border-radius: ${vars.card.borderRadius};
  color: ${vars.colors.text};
  display: block;
  filter: drop-shadow(0 4px 8px rgb(0 0 0 / 4%)) drop-shadow(0 0 2px rgb(0 0 0 / 6%))
    drop-shadow(0 0 1px rgb(0 0 0 / 4%));
  text-decoration: none;

  &:focus-visible {
    outline: 1px solid ${vars.colors.focusRing};
  }
`;

const imageWrapperStyles = css`
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
`;

const imageStyles = css`
  border-radius: inherit;
  display: block;
  margin-inline: -24px;
  margin-top: -24px;
  max-width: initial;
  width: calc(100% + 48px);
`;

const fetchDestinationImage = async (iataCode: string) => {
  if (iataCode) {
    try {
      const destination = await import(`@eti/assets/images/popularRoutes/${iataCode}.webp`);

      return destination.default;
    } catch {
      return null;
    }
  }

  return null;
};

const PopularRoute = ({ destination, header, link }: PopularRouteProps) => {
  const [image, setImage] = useState(undefined);

  useEffect(() => {
    const loadDestinationImage = async () => {
      setImage(await fetchDestinationImage(destination));
    };
    loadDestinationImage();
  }, [destination]);

  return image ? (
    <a className={flightsLinkStyles} data-testid="image-link" href={link}>
      <Card padding={24}>
        <Stack className={imageWrapperStyles} spacing={24}>
          <img alt={header} className={imageStyles} src={image} />
          <Heading level={2}>{header}</Heading>
        </Stack>
      </Card>
    </a>
  ) : null;
};

export default PopularRoute;
